import T from 'i18n-react'
import * as R from 'ramda'
import {
  createSelectorWithPath,
  labelSelectorFunc,
  elementsSelector,
  entitiesSelector
} from 'helpers/ComponentSelectorUtil'

const valuesSelectorFunc = state => state.values ? state.values : []
const hintSelectorFunc = state => (state.defaultValue) ? T.translate(state.defaultValue) : ''

// TODO: refactor following two functions so shared with verticalTableInput

const getElementKeySelector = (id) => {
  return (state) => elementsSelector(state)[id].key
}

// Function should be applied to element.properties of nested dropdown
const getRowFormatSelector = (id) => {
  return (state) => {
    const element = elementsSelector(state)[id]
    const entities = entitiesSelector(state)

    let properties = element.values.items.properties
    delete properties.type
    properties = Object.fromEntries(
      Object.entries(properties).map((e) => {
        const [colKey, { ref, type, items }] = e
        
        if (ref) {
          const sources = Object.values(entities[ref]).map(({value}) => {
            return { value, label: value}
          })
          
          return [colKey, {
            type: 'drop_down',
            sources: sources
          }]
        }

        if (items && type === 'array') {
          return [colKey, {
            type: 'array',
            sources: items.properties
          }]
        }

        return e
      }
    ))

    return properties
  }
}

export {
  getElementKeySelector,
  getRowFormatSelector
}

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const labelSelector = withPath(labelSelectorFunc)
  const valuesSelector = withPath(valuesSelectorFunc)
  const hintSelector = withPath(hintSelectorFunc)

  return {
    hintSelector,
    valuesSelector,
    labelSelector
  }
}
